export function floatNumber(number: number | string, precision = 2): number {
  const [int, fraction] = `${(+number).toFixed(precision)}`.split('.');

  return parseFloat(`${int}${+fraction > 0 ? '.' + fraction : ''}`);
}
